import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ObjectResolverBase } from '../../shared/base/object-resolver-base';

import { Course } from './course';
import { CourseService } from './course.service';

@Injectable()
export class CourseResolver extends ObjectResolverBase<Course> {
  constructor(service: CourseService, router: Router) {
    super(service, router);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course-resolver.service.ts